import { render } from "./NoteModal.vue?vue&type=template&id=3af60f95&scoped=true"
import script from "./NoteModal.vue?vue&type=script&lang=ts"
export * from "./NoteModal.vue?vue&type=script&lang=ts"

import "./NoteModal.vue?vue&type=style&index=0&id=3af60f95&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-3af60f95"

export default script